<template>
	<div class="buy-options">
		<hr>
		<div class="container">
			<h2 class="buy-options-header text-uppercase text-center">Buy Options</h2>
			<div class="buy-options-color-picker">
				<model-picker v-if="totalBuilds > 1" />
				<color-picker class="color-picker-row" />
				<!-- Temporarily removed due to oversold
					<add-streaming-bundle-button
					v-if="$route.meta.group == 'streamer-pc' && streamingBundle.id"
					:accessory="streamingBundle"
					type="streamingBundle" /> -->
				<hard-drive-select
					v-if="['creator-pc', 'h1-mini-pc'].includes($route.name)"
					class="buy-options-hard-drive-select"
				/>
				<monitor-button
					v-if="$route.name != 'creator-pc'"
				/>
				<hr>
			</div>
			<div class="buy-options-buttons">
				<p class="prize-price">
					<span class="prize-price-emphasis">
						<template v-if="['creator-pc', 'h1-mini-pc'].includes(which)">
							<promo-sales-timed class="promo-sales-price">
								<template v-slot:originalContent>
									{{ priceWithStorage | formatMoney(2) }}
								</template>
								<template>
									{{ promoDiscount(priceWithStorage) | formatMoney(2) }}
									<span class="discounted-price">{{ priceWithStorage | formatMoney(2) }}</span>
								</template>
							</promo-sales-timed>

						</template>
						<!-- <template v-else-if="which == 'streaming-pc'">
							{{ priceWithStreamingBundle | formatMoney(0) }}
						</template> -->
						<template v-else-if="which == 'streaming-pc'">
							<promo-sales-timed class="promo-sales-price">
								<template v-slot:originalContent>
									{{ priceWithMonitor | formatMoney(2) }}
								</template>
								<template>
									{{ promoDiscount(build.price) | formatMoney(2) }}
									<span class="discounted-price">{{ build.price | formatMoney(2) }}</span>
								</template>
							</promo-sales-timed>
						</template>
						<template v-else>
							<promo-sales-timed class="promo-sales-price">
								<template v-slot:originalContent>
									{{ priceWithMonitor | formatMoney(2) }}
								</template>
								<template>
									{{ promoDiscount(priceWithMonitor) | formatMoney(2) }}
									<span class="discounted-price">{{ priceWithMonitor | formatMoney(2) }}</span>
								</template>
							</promo-sales-timed>
						</template>
						<span class="currency-code">USD</span>
					</span>
					<span class="prize-price-ship">
						<promo-sales-timed>
							<template v-slot:originalContent>
								{{ pageData.landing_page_sections[1].body | stripTags }}
							</template>
							<template slot-scope="{ phasesInfo: { currentPhase } }">
								<holiday-saving-msg
									v-if="which == 'streaming-pc'"
									:phase="currentPhase"
									text="streamingPC"
								/>
								<holiday-saving-msg
									v-else
									:phase="currentPhase"
									text="creatorAndH1PC"
								/>
							</template>
						</promo-sales-timed>
					</span>
				</p>
				<template>
					<sold-out-button v-if="isOutOfStock" :background-white="true" />
					<div v-else>
						<div class="buy-options__checkout">
							<button class="btn btn-purple text-uppercase" @click="$emit('buy-now', trackingOptions)">
								ADD TO CART
							</button>
						</div>
						<template v-if="!POS_MODE">
							<paybright
								v-if="countryCode == 'CA'"
								:price="financingPrice"
								class="affirm-starter-pc btn affirm-promo"
								@click="$emit('click-quoted-payment', trackingOptions.page_location)"
							/>
							<affirm
								v-else
								:price="financingPrice"
								class="affirm-starter-pc btn affirm-promo"
								color="black"
								@click="$emit('click-quoted-payment', trackingOptions.page_location)"
							/>
						</template>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
// import AddStreamingBundleButton from "./streaming-pc/add-streaming-bundle-button";
import Affirm from "@c/generals/affirm";
import ColorPicker from "./color-picker";
import ModelPicker from "./model-picker";
import Paybright from "@c/generals/paybright";
import HardDriveSelect from "./hard-drive-select";
import MonitorButton from "./monitor-button";
import { promoDiscount } from "@u/helpers";
import SoldOutButton from "./soldout-button";
import PromoSalesTimed from "@/components/promo-sales-timed";
import HolidaySavingMsg from "@c/generals/holiday-saving-msg";

export default {
	name: "BuyOptions",
	components: {
		// AddStreamingBundleButton,
		PromoSalesTimed,
		HolidaySavingMsg,
		Affirm,
		ColorPicker,
		HardDriveSelect,
		ModelPicker,
		MonitorButton,
		Paybright,
		SoldOutButton
	},
	props: {
		which: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			trackingOptions: {
				page: "Product Page",
				page_location: "Bottom"
			}
		};
	},
	computed: {
		...mapState({
			build: state => state.StarterPc.builds[state.StarterPc.buildsIndex],
			builds: state => state.StarterPc.builds,
			cart: state => state.StarterPc.cart,
			countryCode: state => state.User.location.country_code,
			pageData: state => state.StarterPc.pageData,
			total: state => state.StarterPc.total,
			selectedMonitor: state => state.StarterPc.selectedMonitor[state.StarterPc.which],
			selectedStorage: state => state.StarterPc.selectedStorage,
			streamingBundle: state => state.StarterPc.accessories.streamingBundle[0] || {}
		}),
		...mapGetters({
			totalBuilds: "StarterPc/totalBuilds"
		}),
		financingPrice() {
			let price = this.priceWithMonitor;
			price = this.which == "h1-mini-pc" && this.priceWithStorage || price;
			price = this.which == "creator-pc" && this.priceWithStorage || price;
			price = this.which == "streaming-pc" && this.priceWithStreamingBundle || price;
			return price;
		},
		isOutOfStock() {
			const build = this.build.variants.find((variant) => {
				return variant.case_id == this.cart.case.id;
			});

			return build && build.stock == 0;
		},
		priceWithMonitor() {
			return Number(this.build.price) +
				(this.selectedMonitor && this.selectedMonitor.variants ? Number(this.selectedMonitor.variants[0].price) : 0);
		},
		priceWithStorage() {
			return Number(this.build.price) +
				(this.selectedStorage && this.selectedStorage.variants ? Number(this.selectedStorage.variants[0].price) : 0);
		},
		priceWithStreamingBundle() {
			return Number(this.build.price) +
				(this.cart.streamingBundle.id ? Number(this.cart.streamingBundle.price) : 0);
		},
		savingsPrice() {
			if (this.which == "creator-pc") {
				return this.priceWithStorage;
			}

			if (this.which == "streaming-pc") {
				return this.priceWithStreamingBundle;
			}

			return this.priceWithMonitor;
		}
	},
	methods: {
		promoDiscount
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.buy-options {
	padding-bottom: 70px;

	hr {
		border-top: 1px solid #dadde0;
		margin-top: 0;
	}

	.btn-purple {
		display: block;
		margin: 0 auto 16px;
		background: $purple;
		border-color: $purple;
		width: 100%;

		&:hover, &:focus {
			background: transparent;
			color: $purple;
		}
	}

	& > div {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	&-header {
		color: #444259;
		font-size: 36px;
		margin-bottom: 0px;

		@media (min-width: 320px) and (max-width: 580px) {
			display: block;
			width: 100%;
			text-align: left;
			margin-top: 3px;
		}
	}

	&-color-picker,
	&-buttons {
		width: 722px;

		@media (min-width: 320px) and (max-width: 580px) {
			width: 100%;
		}
	}

	&-color-picker {
		margin-bottom: 21px;

		.color-picker-row {
			margin-bottom: 48px;

			@media (min-width: 320px) and (max-width: 580px) {
				margin-bottom: 0;
			}
		}

		.buy-options-hard-drive-select {
			margin-bottom: 49px;
		}
	}

	&-buttons {
		.prize-price {
			margin-bottom: 5px;

			&-emphasis {
				color: $purple;
				font-size: 32px;

				.currency-code {
					font-size: 14px;
					font-weight: 200;
					margin-left: -3px;
				}
			}


			&-ship {
				font-size: 16px;
				opacity: 0.7;
				color: #5f707f;
				display: block;

				@media (min-width: 320px) and (max-width: 580px) {
					font-size: 14px;
					max-width: 220px;
					line-height: 16px;
				}
			}
		}
	}
}

.buy-options-buttons::v-deep {
	.holiday-savings-msg {
		p {
			color: #000;
		}

		br {
			display: none;
		}
	}

	.discounted-price {
		text-decoration: line-through;
		font-size: 14px !important;
		margin: 0 !important;
	}

	.promo-sales-price {
		display: inline-block;
	}
}
</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.affirm-starter-pc {
	width: 100%;
	border: 1px solid #dadde0;
	white-space: initial;

	@media (max-width: 580px) {
		padding: 16px 45px;
	}
}

.buy-options {
	&__checkout {
		display: flex;
	}
}
</style>
